<template>
<!-- 拟建项目 -->
    <div class="contain desPro">
        <div class="box">
            <div class="build-bar">
             <div>
                <span>移交人：</span>
                <el-input placeholder="请输入移交人" v-model="search.createBy" style="width:12vw;"></el-input>
             </div>
              <div>
                <span>接收人：</span>
                <el-input placeholder="请输入接收人" v-model="search.receiveBy" style="width:12vw;"></el-input>
             </div>   
             <div>
                <span>交接状态：</span>
                <el-select v-model="search.yesNo" placeholder="请选择" clearable class="tqmInfo-val" style="">
                    <el-option
                      v-for="item in status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
             </div>  
             <div>
                <el-input placeholder="请输入合同名称" v-model="search.contractName " style="width:12vw;"></el-input>
              </div> 
             <div style="width:300px">
                <el-button type="primary" class="add-user" @click="doFilter" >查询</el-button>
             </div>   
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号">
                      <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                       </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="合同负责人">
                        <template slot-scope="scope">
                          <span>{{ scope.row.principal }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同创建者">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createBy }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="移交时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="移交人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.handOver }}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="接收时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.receiveDate }}</span>
                        </template>
                      </el-table-column>
                  <el-table-column label="接收人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.receiveBy }}</span>
                        </template>
                      </el-table-column>
                   <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.yesNo=='0'">未开始</span>
                            <span v-else-if="scope.row.yesNo=='1'">已接收</span>
                            <span v-else-if="scope.row.yesNo=='2'">未接收</span>
                        </template>
                    </el-table-column>
                     
                    <el-table-column label="备注">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="附件">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.file && scope.row.file!=''" type="text" @click="toFile(scope.row.file)">查看</el-button>
                            <el-button v-else type="text" disabled>查看</el-button>
                            <!-- <span>{{ scope.row.file}}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)">移交记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;"
                ></el-pagination>
                <!-- 弹出框 -->           
                <el-dialog
                title="移交记录"
                :visible.sync="dialogTableVisible"
                style="border-bottom:1px solid #000;color:#000;"
                >
                <div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    合同名称：{{addForm.contractName}}
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    接收人：{{addForm.receiveBy}}
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    移交附件：<el-button v-if="addForm.file && addForm.file!=''" type="text" @click="toFile(addForm.file)">查看</el-button>
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    备注：{{addForm.note}}
                    </div>
                </div>
                <div style="display:flex;justify-content: space-between;padding: 10px;font-weight:bolder">
                    移交记录:
                
                <el-table :data="gridData"  height="50vh">
                    <el-table-column type="index" label="序号" width="100"></el-table-column>
                    <el-table-column property="handOver" label="移交人"></el-table-column>
                    <el-table-column property="createDate" label="移交时间"></el-table-column>
                    <el-table-column property="receiveBy" label="接收人"></el-table-column>
                    <el-table-column property="receiveDate" label="接收时间"></el-table-column>
                    <el-table-column property="yesNo" label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.yesNo=='0'">未开始</span>
                            <span v-else-if="scope.row.yesNo=='1'">已接收</span>
                            <span v-else-if="scope.row.yesNo=='2'">未接收</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="note" label="备注"></el-table-column>
                    <el-table-column property="time" label="附件">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.file && scope.row.file!=''" type="text" @click="toFile(scope.row.file)">查看</el-button>
                            <el-button v-else type="text" disabled>查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            count:0,
            count1:0,
            count2:0,
            search:{
                receiveBy:'',  //接收人
                createBy:'',  //提交人
                yesNo:'',//是否同意，0未开始， 1已接收，2未接受
                contractName:'', //类型筛选
            },
            listData:[],
            gridData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            diaTitle:"",
            labelPosition: 'right',
            dataText:"数据加载中...",
            projects:[],
            addFormVisible:false,
            addForm: {
                id:'',
                name:'',
                entId:'',
                entProjectId:'',
                serialNum:'',//合同编号
                unitKind:'',
                principal:'',//合同负责人
                description:'',//备注
                overview:'',
                unitType:''
            },
            
            unitKinds:[{label:'项目采购类',value:'1'},{label:'管理服务类',value:'2'}],

            status:[{
             label:'未开始',value:'0',
            },{
             label:'已接收',value:'1',
            },
            {
             label:'未接收',value:'2',
            },
            ], 
            dialogTableVisible:false      

        }
    },
    mounted() {
        // this.groupId = this.$store.state.groupId;
        // if(''==this.groupId){
        //     this.$store.commit('setGroupId');
        //     this.groupId = this.$store.state.groupId;
        // }
        this.groupId = util.session.get('groupId')
        this.addForm.entId=this.groupId

        this.getData()
    },
    methods:{
        doFilter(){
           
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            // this.search.contractName = this.contractName
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.selectContractHandRecord(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        list[i].statisticsPercentage = parseInt(list[i].statisticsPercentage*100)
                        list[i].biddingPercentage = parseInt(list[i].biddingPercentage*100)
                        if(list[i].constructionPercentage!='/'){
                         list[i].constructionPercentage = parseInt(list[i].constructionPercentage*100)+'%' ||'/'
                        }                                      
                    }
                    that.listData = list;
                    // console.log(that.listData)
                    that.totalItems = resp.data.data.PageInfo.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
    
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            this.dialogTableVisible=true
            this.addForm = row
            var that = this
            myHttp.selectContractHandRecordBycontractInitId({
                contractInitId:row.contractInitId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.List||[]
                    that.gridData = list
                }
            })
        },
        //查看文件
        toFile(url){
            window.open(base.httpCtx+url)
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* font-size: 18px; */
        /* color: #2058D9; */
    }
    .box{
        /* margin-top: 15px; */
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 55px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
         justify-content: space-between;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
 .el-form-item__label{
     color: inherit;
 }
    
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    .caozuo{
        display: flex;
        justify-content: flex-end;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>